<template>
  <div>
    <b-overlay :show="showmanowanderley" rounded="sm">
    <b-row>
      <b-col sm="12">
        <p>
          <strong>Detalhamento da Restituição Efetuada</strong>
        </p>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="4">
        <b-form-group label="Valor Restituição (LÍQUIDO em R$)" label-size="sm" label-class="text-secondary">
          <span class="font-weight-bold">
            {{formataReal(restituicao.valor_restituicao_liquido)}}
          </span>
        </b-form-group>
      </b-col>
      <b-col cols="4">
        <b-form-group label-size="sm" label-class="text-secondary">
          <template slot="label"
            ><span>Percentual da Correção Monetária (%)&nbsp;</span
            ><b-icon
              v-b-tooltip.hover
              title="Detalhes sobre o cálculo da restituição poderão ser consultados no respectivo protocolo no Portal de Serviços"
              class="text-dark"
              icon="question-circle-fill"
            ></b-icon
          ></template>
          <span class="font-weight-bold">
            {{(restituicao.percentual_correcao_monetaria)}}
          </span>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="4">
        <b-form-group
          label="Valor da Restituição (FINAL em R$)"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{formataReal(restituicao.valor_restituicao_final)}}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group
          label="Data da Restituição (depósito / transferência bancária)"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{ temValor(dataBrasil(restituicao.data_restituicao_bancaria)) }}
          </span>
        </b-form-group>
      </b-col>
    </b-row> 
    
    <hr />

    <b-row>
      <b-col sm="12">
        <p>
          <strong>Conta Bancária restituída</strong>
        </p>
      </b-col>
    </b-row>
    

    <b-row>
      <b-col sm="4">
        <b-form-group label="Nome titular da conta" label-size="sm" label-class="text-secondary">
          <span class="font-weight-bold">
            {{temValor(restituicao.nome_titular_conta)}}            
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group label="CPF / CNPJ do titular da conta " label-size="sm" label-class="text-secondary">
          <span class="font-weight-bold">
            {{temValor(restituicao.cpf_cnpj_titular_conta)}}
          </span>
        </b-form-group>
      </b-col>
    </b-row>    


    <b-row>
      <b-col sm="2">
        <b-form-group label="Banco" label-size="sm" label-class="text-secondary">
          <span class="font-weight-bold">
            {{temValor(restituicao.banco_restituicao)}}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="2">
        <b-form-group label="Agência" label-size="sm" label-class="text-secondary">
          <span class="font-weight-bold">
            {{temValor(restituicao.agencia_restituicao)}}
          </span>
        </b-form-group>
      </b-col>      
    </b-row>      


    <b-row>
      <b-col sm="2">
        <b-form-group label="Tipo Conta" label-size="sm" label-class="text-secondary">
          <span class="font-weight-bold">
            {{temValor(restituicao.tipo_conta_restituicao)}}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="2">
        <b-form-group label="Operação" label-size="sm" label-class="text-secondary">
          <span class="font-weight-bold">
            {{temValor(restituicao.operacao_restituicao)}}
          </span>
        </b-form-group>
      </b-col>      
      <b-col sm="4">
        <b-form-group label="N da  Conta" label-size="sm" label-class="text-secondary">
          <span class="font-weight-bold">
            {{temValor(restituicao.numero_conta_restituicao)}}
          </span>
        </b-form-group>
      </b-col>        
    </b-row> 

    <hr />

    <b-row>
      <b-col sm="12">
        <p>
          <strong>Solicitações de Restituição de Pagamento</strong>
        </p>
      </b-col>
    </b-row>    

    <div class="p-3" v-if="listaRestituicao.length > 0">
        <div>
          <b-row>
            <b-col>
              <b-table
                stacked="sm"
                show-empty
                small
                striped
                bordered
                :sticky-header="true"
                :no-border-collapse="false"
                responsive
                :fields="fieldsDetail"
                :items="listaRestituicao"
              >
                <template v-slot:empty>
                  Não existem valores cadastrados
                </template>
   
                <template v-slot:cell(situacao)="data">
                  {{data.item.status_restituicao_pagamento ? data.item.status_restituicao_pagamento.descricao : "-"}}
                </template>

                <template v-slot:cell(motivo)="data">
                  <span v-if="data.item.status_restituicao_pagamento.codigo == 4">{{data.item.motivo_restituicao ? data.item.motivo_restituicao.descricao : "-"}}</span>
                  <span v-if="data.item.status_restituicao_pagamento.codigo == 2">{{data.item.motivo_indeferimento_restituicao ? data.item.motivo_indeferimento_restituicao.descricao : "-"}}</span>

                  
                </template>

                <template v-slot:cell(data_solicitacao)="data">
                  {{temValor(dataBrasil(data.item.data_solicitacao))}}
                </template>

                <template v-slot:cell(data_atendimento)="data">
                  {{temValor(dataBrasil(data.item.data_atendimento))}}
                </template>
                
                    
       
              </b-table>
            </b-col>
          </b-row>
        </div>
      </div>

    </b-overlay>


    <hr />
    <div >
      <b-row class="mt-3">
        <b-col>
          <font-awesome-icon
            size="lg"
            :icon="['fa', 'circle-info']"
            class="mr-1"
          />
          <u
            ><strong
              >Serviços oferecidos no Portal de Serviços da PBH</strong
            ></u
          >
        </b-col>
      </b-row>
      <b-card class="mb-2 mt-1" no-body>
        <b-row class="p-2">
          <b-col>
            <b-link
              size="sm"
              class="text-primary"
              style="font-weight: bold"
              target="_blank"
              href="https://servicos.pbh.gov.br/servicos/i/5e4d86d7e1bf5e706b516f06/5dc8470253fd6b5bbd99185f/servicos+restituicao-de-multa-de-transito"
              title="Serviço Solicitação de Efeito Suspensivo  -  Portal de Serviços PBH"
            >
              <font-awesome-icon
                size="lg"
                :icon="['fa', 'arrow-up-right-from-square']"
              />
              Serviço Restituição Pagamento de Multa de Trânsito - Portal de Serviços PBH
            </b-link>
          </b-col>
        </b-row>
        <b-row class="p-2">
          <b-col>
            <p>
              Se deseja apresentar solicitação de Restituição de Pagamento de Multa de Trânsito, informando dados do AIT, enviando comprovantes bancários de pagamento em duplicidade, multa paga e enquadrada como cancelada ou convertida em Advertência ou Deferimento da Defesa ou Recurso JARI, do Auto de Infração de Trânsito - AIT, utilize o serviço específico no Portal de Serviços da PBH.
            </p>
            <p>
              Já abriu sua solicitação? Para mais detalhes sobre sua solicitação já aberta, acesse o Portal de Serviços da PBH com os dados do protocolo e/ou acesso GovBr (vide Área de Relacionamento)
            </p>
   
          </b-col>
        </b-row>
      </b-card>
    </div>

  </div>
</template>

<script>
import AutoInfracaoTransito from "@/models/AutoInfracaoTransito";
import PessoaAutoInfracaoTransito from "@/models/PessoaAutoInfracaoTransito";
import Notificacao from "@/models/Notificacao";
import { helperDatas, helperNumeros } from "@/helpers";


export default {
  name: "NotificacaoNAP",

  components: {
    
  },

  props: {
    dadosAit: {
      type: Object,
      default: function () {
        return {};
      },
    },
    auto_infracao_transito: {
      type: Object,
      default: function () {
        return new AutoInfracaoTransito();
      },
    },
  },

  
  data() {
    return {
      notificacao: new Notificacao(),
      dom_publicacao: {},
      possuidor: new PessoaAutoInfracaoTransito(),
      carregado: false,
      showmanowanderley: false,
      listaRestituicao:[],
      restituicao:{
        valor_restituicao_liquido:null,
        percentual_correcao_monetaria:null,
        valor_restituicao_final:null,
        data_restituicao_bancaria:null,
        nome_titular_conta:null,
        cpf_cnpj_titular_conta:null,
        banco_restituicao:null,
        agencia_restituicao:null,
        tipo_conta_restituicao:null,
        operacao_restituicao:null,
        numero_conta_restituicao:null
      },

      fieldsDetail: [
        {
          key: "protocolo_bhdigital",
          label: "Protocolo *",
          thStyle: { width: "160px" },
        },
        { key: "data_solicitacao", label: "Data Solicitação" },
        { key: "situacao", label: "Situação" },
        { key: "motivo", label: "Motivo" },
        { key: "data_atendimento", label: "Data Atendimento" },
      ],

    };
  },

  watch: {},

  methods: {

    listaCpfCnpf() {
      var keys = Object.keys(this.$store.getters.userInfo.attributes);
      const result = keys.filter(
        (element) => element.substring(10, 0) == "govbr_cnpj"
      );
      let listaCpfCnpj = [];
      listaCpfCnpj.push(this.$store.getters.userInfo.preferred_username);
      if (result.length > 0) {
        result.forEach((element) => {
          listaCpfCnpj.push(element.substring(25, 11));
        });
      }
      return listaCpfCnpj;
    }, 


    buscarlistaRestituicao() 
    {
      this.showmanowanderley = true;
      this.$api.Multa.buscarlistaRestituicao({ hash: this.auto_infracao_transito.hash, ld: this.listaCpfCnpf() })
        .then(async (response) => 
        {
          this.showmanowanderley = false;
          if (response.data.success && response.data.data) 
          {
            if (response.data.data) 
            {
              this.listaRestituicao = response.data.data.listaRestituicao;
              this.restituicao = response.data.data.restituicao;
            }
          }
        })
        .catch(() => {
          this.showmanowanderley = false;
        });
    },

    temValor(valor) {
      return valor ? valor : "-";
    },

    formataReal(vlaor) {
      return helperNumeros.formatReal(vlaor);
    },

    dataBrasil(vlaor) {
      return helperDatas.dataBrasil(vlaor);
    },

    dataHoraBrasil(vlaor) {
      return helperDatas.dataHoraBrasil(vlaor);
    },

    
    loadInfos() 
    {
      if (!this.carregado) 
      {
        this.carregado = true;
        this.buscarlistaRestituicao();
      }
    },
  }

};
</script>

<style scoped>
.input-group-sm > .form-control {
  font-weight: 700 !important;
}
</style>